/**
 * Shared password and lockout policy constants.
 *
 * Keep this module free of heavy dependencies so browser code can import
 * static auth policy values without pulling in server-only or large logic.
 */
export const PASSWORD_POLICY = {
  MIN_LENGTH: 12,
  MIN_SCORE: 3,
  MAX_LENGTH: 128,
} as const;

export const PASSWORD_GUIDANCE = {
  MIN_LENGTH_LABEL: `Use at least ${PASSWORD_POLICY.MIN_LENGTH} characters.`,
  AVOID_COMMON_LABEL: 'Avoid common passwords and anything based on your name or email.',
  PASSPHRASE_LABEL: 'A memorable passphrase is usually easier to keep strong.',
} as const;

export const LOCKOUT_CONFIG = {
  MAX_ATTEMPTS: 5,
  LOCKOUT_DURATION_MS: 15 * 60 * 1000,
  WINDOW_DURATION_MS: 30 * 60 * 1000,
} as const;
